module.exports = __webpack_public_path__ + "static/media/category3.37fcc822.jpg";